
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Vue from 'vue'
import ImageLightbox from './ImageLightbox.vue'
import LazyBackgroundImage from './LazyBackgroundImage.vue'

export default {
    data() {
        return {
          isOpeningLightbox: false,
          swiperOptions: {
            pagination: {
              el: '.'+this.sliderId+' .swiper-pagination',
              type: 'bullets',
              clickable: true,
            },
            effect: 'slide',
            autoplay: {delay: 5000},
            speed: 1000,
            autoHeight: true,
            keyboard: true,
            loop: this.loop,
            slidesPerView: this.slidesPerView,
            grabCursor: true,
            spaceBetween: this.padding,
            runCallbacksOnInit: true,
            navigation: {
              nextEl: '.'+this.sliderId+' .swiper-button-next',
              prevEl: '.'+this.sliderId+' .swiper-button-prev',
            },
            breakpoints: {
              1024: {
                slidesPerView: this.slidesPerView,
                spaceBetween: this.padding,
              },
              768: {
                slidesPerView: this.slidesPerView,
                spaceBetween: this.padding,
              },
              640: {
                slidesPerView: 1, //(this.slidesPerView > 2) ? this.slidesPerView / 2 : this.slidesPerView,
                spaceBetween: 0, //(this.padding > 0) ? this.padding / 2 : this.padding,
              },
              320: {
                slidesPerView: 1,
                spaceBetween: 0,
              },
            },
          },
        };
    },

    props: {
      debug: {
        type: Boolean,
        default: true,
      },
      loop: {
        type: Boolean,
        default: false,
      },
      showPagination: {
        type: Boolean,
        default: false,
      },
      showNavigation: {
        type: Boolean,
        default: false,
      },
      slidesPerView: {
        type: Number,
        default: 1,
      },
      padding: {
        type: Number,
        default: 0,
      },
      images: {
        type: Array,
        default: function() {
          return [];
        },
      },
      sliderId: {
        type: String,
        default: function() {
          // If not set, generate a unique id
          var S4 = function() {
             return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
          };
          return 'slider-'+(S4()+S4()+'-'+S4()+'-'+S4()+'-'+S4()+'-'+S4()+S4()+S4());
        },
      },
      lightbox: {
        type: Boolean,
        default: true,
      },
    },

    computed: {
      swiper() {
        return this.$refs.slider.swiper;
      },
    },

    watch: {

    },

    methods: {
      sliderClicked(e) {

        console.log('clicked!');

        e.preventDefault();
        e.stopPropagation();

        if(this.isOpeningLightbox) return;

        var self = this;

        let index = parseInt(e.target.getAttribute('data-index'));
        self.didSelectOpenImageGallery(index);
        self.isOpeningLightbox = true;

        setTimeout(function() {
          self.isOpeningLightbox = false;
        }, 500);


      },
      onSwiperSlideChangeTransitionStart: function() {
        this.$emit('will-change-index', this.swiper.realIndex);
      },
      onSwiperSlideChangeTransitionEnd: function() {
        this.$emit('did-change-index', this.swiper.realIndex);
      },
      didSelectOpenImageGallery: function(startIndex = 0) {

        if(!this.lightbox) return;

        var ComponentClass = Vue.extend(ImageLightbox),
            instance = new ComponentClass({
                propsData: { imageData: this.images, startIndex: startIndex },
            })
            instance.$mount();

            document.body.appendChild(instance.$el);
      },
    },

    components: {
      swiper,
      swiperSlide,
      LazyBackgroundImage,
    },

    created() {

    },
    mounted() {
      var self = this;

      setTimeout(function() {
        // Triggering an update after 0.5s to make sure the views are properly spaced according to
        // the current window size. This shouldn't really be necessary but occasionally I have found
        // the rendering is slightly off until the window is resized, so just making sure.
        self.swiper.update();
      }, 2000);
    },
};




// WEBPACK FOOTER //
// ./scripts/vue/ImageSlider.vue